import { z } from "zod";

// Porte das diretivas dc* do legado (form-usuario.html):
// nome/email/usuario: dc-not-empty; usuario: dc-min-length="5";
// confirmacaoSenha: dc-equal="{{registro.senha}}".
export const usuarioFormSchema = z
  .object({
    id: z.number().optional(),
    nome: z.string().min(1, "Informe o nome."),
    email: z.string().min(1, "Informe o email.").email("Email inválido."),
    usuario: z.string().min(5, "Mínimo de 5 caracteres."),
    senha: z.string().optional(),
    confirmacaoSenha: z.string().optional(),
  })
  .refine((data) => (data.senha ?? "") === (data.confirmacaoSenha ?? ""), {
    message: "As senhas não coincidem.",
    path: ["confirmacaoSenha"],
  });

export type UsuarioFormValues = z.infer<typeof usuarioFormSchema>;
